import {useQuery} from '@apollo/client/react';
import type {FragmentType} from '../generated/fragment-masking';
import {
  ViewerDocument,
  ViewerFields_UserFragmentDoc,
} from '../generated/graphql';

export type Viewer = FragmentType<typeof ViewerFields_UserFragmentDoc>;

export const useViewer = ({skip}: {skip: boolean}) => {
  const {data, loading, error} = useQuery(ViewerDocument, {skip});

  return {
    viewer: data?.viewer ?? null,
    loading,
    error,
  };
};
